module.exports = __webpack_public_path__ + "img/03d.196ff15d.svg";